import { render, staticRenderFns } from "./NsProductRecsCarousel.vue?vue&type=template&id=4ec687cd&"
import script from "./NsProductRecsCarousel.vue?vue&type=script&lang=js&"
export * from "./NsProductRecsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsProductRecsCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ec687cd')) {
      api.createRecord('4ec687cd', component.options)
    } else {
      api.reload('4ec687cd', component.options)
    }
    module.hot.accept("./NsProductRecsCarousel.vue?vue&type=template&id=4ec687cd&", function () {
      api.rerender('4ec687cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/product-components/components/NsProductRecsCarousel.vue"
export default component.exports